import { render, staticRenderFns } from "./TinyMceEditor.vue?vue&type=template&id=797204b9&scoped=true"
import script from "./TinyMceEditor.vue?vue&type=script&lang=js"
export * from "./TinyMceEditor.vue?vue&type=script&lang=js"
import style0 from "./TinyMceEditor.vue?vue&type=style&index=0&id=797204b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797204b9",
  null
  
)

export default component.exports